<template>
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="currentColor"
    aria-hidden="true">
    <path
      d="M12 3C6.8 3 3 6.4 3 10.6c0 2.3 1.2 4.4 3.1 5.8 0 .9-.5 2-1.3 2.9 1.5-.2 2.9-.8 3.9-1.5 1 .3 2.1.5 3.3.5 5.2 0 9-3.4 9-7.6S17.2 3 12 3z" />
  </svg>
</template>
